import { render, staticRenderFns } from "./LinkPopupV2.vue?vue&type=template&id=6b55830e&scoped=true"
import script from "./LinkPopupV2.vue?vue&type=script&lang=js"
export * from "./LinkPopupV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55830e",
  null
  
)

export default component.exports